<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2022 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2022</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">31 30 29 28 27 26 25 24 23 22     1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-80674-7 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-80691-4 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-80688-4 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226806884.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226806884.001.0001</a></p>
<p class="crtf">This publication is made possible in part by the Barr Ferree Foundation Fund for Publications, Department of Art and Archaeology, Princeton University.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Names: Womack, Autumn, author.</p>
<p class="cip">Title: The matter of Black living : the aesthetic experiment of racial data, 1880–1930 / Autumn Womack.</p>
<p class="cip">Description: Chicago : University of Chicago Press, 2022. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2021030560 | ISBN 9780226806747 (cloth) | ISBN 9780226806914 (paperback) | ISBN 9780226806884 (ebook)</p>
<p class="cip">Subjects: LCSH: African Americans in literature. | African Americans in motion pictures. | African Americans in art. | American literature—20th century—History and criticism. | Motion pictures—United States—History—20th century. | Photography—United States—History—20th century. | African Americans—Social life and customs—19th century. | African Americans—Social life and customs—20th century. | Social surveys—United States.</p>
<p class="cip">Classification: LCC PS173.N4 W66 2022 | DDC 810.9/896073—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2021030560" target="_blank">https://lccn.loc.gov/2021030560</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-womack-0004.vue?71934390